import { defineComponent, computed, openBlock, createBlock, unref, normalizeProps, mergeProps, withCtx, renderSlot, h, Fragment } from "vue";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset.js";
import { u as useLocalConfig, p as provideLocalConfig } from "../../composables/useLocalConfig.js";
import { u as useGlobalConfigProvider } from "./hooks/useGlobalConfigProvider.js";
import { r as renderSlotNodes } from "../../utils/headless.js";
import { u as useColors } from "../../composables/useColors.js";
const CssVarsRenderer = defineComponent({
  name: "VaCssVarsRenderer",
  inheritAttrs: false,
  setup(props, { slots, attrs }) {
    const { colorsToCSSVariable, colors } = useColors();
    const style = computed(() => {
      return colorsToCSSVariable(colors);
    });
    return () => h(Fragment, attrs, renderSlotNodes(slots.default, {}, {
      style: style.value
    }) || void 0);
  }
});
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaConfig",
    inheritAttrs: false
  },
  __name: "VaConfig",
  props: {
    ...useComponentPresetProp,
    components: { type: Object, default: () => ({}) },
    colors: { type: Object },
    i18n: { type: Object }
  },
  setup(__props) {
    const props = __props;
    const prevChain = useLocalConfig();
    const nextChain = computed(() => [...prevChain.value, props.components]);
    provideLocalConfig(nextChain);
    useGlobalConfigProvider(computed(() => {
      const config = {};
      if (props.colors) {
        config.colors = props.colors;
      }
      if (props.i18n) {
        config.i18n = props.i18n;
      }
      return config;
    }));
    const doRenderCssVars = computed(() => {
      return Boolean(props.colors);
    });
    return (_ctx, _cache) => {
      return doRenderCssVars.value ? (openBlock(), createBlock(unref(CssVarsRenderer), normalizeProps(mergeProps({ key: 0 }, _ctx.$attrs)), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16)) : renderSlot(_ctx.$slots, "default", { key: 1 });
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaConfig.vue_vue_type_script_setup_true_lang.js.map
